import { Input } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';
import React from 'react';
import { Controller } from 'react-hook-form';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

interface TextInputInterface {
    name: string;
    control: any;
    placeholder?: string;
    errors?: any;
    isRequired?: any;
}

function TextInputCell({
    control,
    name,

    placeholder,

    errors = {},
    isRequired = false,
}: TextInputInterface) {
    const parts = name.split('.');
    const arrayName = parts[0];
    const index = parseInt(parts[1], 10);
    const fieldName = parts[2];

    const getBorderClass = () => {
        if (errors && errors[name] && errors && errors[arrayName]) {
            return 'border-[#d32f2f]';
        } else if (errors && !!errors[arrayName] && !!errors[arrayName][index] && !!errors[arrayName][index][fieldName]) {
            return 'border-[#d32f2f]';
        } else {
            return 'border-[#D9D9D9]';
        }
    };

    return (
        <div className={`min-w-[100px] border ${getBorderClass()} flex items-center p-[1px] justify-center `}>
            <Controller
                name={name}
                control={control}
                rules={{ required: isRequired }}
                render={({ field }) => (
                    <MDEditor
                        style={{ maxHeight: 540 }}
                        value={field.value}
                        onChange={(value: any) => field.onChange(value)}
                        preview="live"
                        previewOptions={{
                            remarkPlugins: [remarkMath],
                            rehypePlugins: [rehypeKatex],
                        }}
                    />
                )}
            />
        </div>
    );
}

export default TextInputCell;
